import { FC } from "react";
import {
  connectCurrentRefinements,
  connectStateResults,
} from "react-instantsearch-dom";
import {
  CurrentRefinementsProvided,
  StateResultsProvided,
} from "react-instantsearch-core";
import { NoProductsFound } from "src/molecules/NoProductsFound";

const CustomCurrentRefinements: FC<
  CurrentRefinementsProvided & StateResultsProvided
> = ({ items, refine, isSearchStalled }) => {
  return (
    <>
      {!isSearchStalled ? (
        <NoProductsFound
          onResetFilters={
            items && items.length
              ? () => {
                  refine(items);
                }
              : undefined
          }
        />
      ) : null}
    </>
  );
};

const NoAlgoliaProductsFound = connectStateResults(
  connectCurrentRefinements(CustomCurrentRefinements)
);

export default NoAlgoliaProductsFound;
